import axios from 'axios'

export const request = axios.create({
 baseURL: '/customer',
 timeout: 6000
})

request.interceptors.request.use(config => {
 return config
})

request.interceptors.response.use(response => {

 const { data } = response
 return data
})